export default __webpack_public_path__ + "static/media/3.605c07b0.jpg";